import React, { useState } from "react";
import Select from "react-select";
import Flowchart from "flowchart-react";
import { ConnectionData, NodeData } from "flowchart-react/dist";
export default function FlowChart() {
  const [nodes, setNodes] = useState([
    {
      type: "start",
      title: "Start",
      x: 150,
      y: 190,
      id: 1
    },
    {
      type: "end",
      title: "Stop",
      x: 500,
      y: 190,
      id: 2
    },
    {
      x: 330,
      y: 190,
      id: 3,
      title: "Joyce",
      type: "operation"
    },
    {
      x: 330,
      y: 300,
      id: 4,
      title: () => {
        return "No approver";
      },
      type: "operation"
    }
  ]);
  const [newNode, setNewNode] = useState({
    id: "",
    x: "",
    y: "",
    title: "",
    type: ""
  });
  const [newConnection, setNewConnection] = useState([
    {
      source: { id: "", position: "" },
      destination: { id: "", position: "" },
      type: "",
      title: ""
    }
  ]);
  const [nodeData, setNodeData] = useState([]);
  const [displayInput, setDisplayInput] = useState(false);
  const [displayInput2, setDisplayInput2] = useState(false);
  const [conns, setConns] = useState([
    // {
    //   source: { id: "", position: "" },
    //   destination: { id: "", position: "" },
    //   type: "success"
    // }
  ]);
  function saveChart() {
    let fd = new FormData();

    for (let i = 0; i < nodeData.length; i++) {
      fd.append(`node_id_${i}`, nodeData[i].id);
      fd.append(`node_title_${i}`, nodeData[i].title);
      fd.append(`node_type_${i}`, nodeData[i].type);
      fd.append(`node_x_${i}`, nodeData[i].x);
      fd.append(`node_y_${i}`, nodeData[i].y);
    }
    for (let j = 0; j < conns.length; j++) {
      fd.append(`connection_${j}`, conns[j].source.id);
      fd.append(`connection_${j}`, conns[j].source.position);
      fd.append(`connection_${j}`, conns[j].destination.id);
      fd.append(`connection_${j}`, conns[j].destination.position);
      fd.append(`connection_${j}`, conns[j].type);
    }
    for (var [key, value] of fd.entries()) {
      console.log(key, value);
    }
  }
  return (
    <div>
      <div className="d-flex justify-content-around align-items-center mt-3">
        <div
          className="mx-5 "
          style={{
            visibility: displayInput ? "visible" : "hidden"
          }}
        >
          <input
            type="text"
            className="form-control "
            value={newNode.title}
            onBlur={() => {
              setDisplayInput(false);
            }}
            onChange={e => {
              setNewNode(prev => {
                return { ...prev, title: e.target.value };
              });
              setNodeData(prev =>
                prev.map(val => {
                  if (newNode.id == val.id) {
                    return { ...val, title: e.target.value };
                  }
                  return val;
                })
              );
            }}
          />
        </div>
        <div style={{ visibility: displayInput2 ? "visible" : "hidden" }}>
          {/* <input
            type="text"
            className="form-control"
            value={newConnection.title}
            onBlur={() => {
              setDisplayInput2(false);
            }}
            onChange={e => {
              setNewConnection(prev => {
                return { ...prev, title: e.target.value };
              });
              console.log("newconn", newConnection);
              setConns(prev =>
                prev.map(val => {
                  if (newConnection.destination.id == val.id) {
                    return { ...val, title: e.target.value };
                  
                  }
                  return val;
                })
              );
            }}
          /> */}
          <label>connection type :</label>
          <select
            onBlur={() => {
              setDisplayInput2(false);
            }}
            onChange={e => {
              setNewConnection(prev => {
                return { ...prev, type: e.target.value };
              });
              setConns(prev =>
                prev.map(val => {
                  if (newConnection.destination.id == val.destination.id) {
                    return { ...val, type: e.target.value };
                  }
                  return val;
                })
              );
            }}
          >
            <option value="success">success</option>
            <option value="fail">fail</option>
          </select>
        </div>
        <div>
          <button className="btn btn-success mx-3" onClick={saveChart}>
            ذخیره
          </button>
        </div>
      </div>
      <Flowchart
        onChange={(nodeData, connections) => {
          setNodeData(nodeData);
          setConns(connections);
          console.log("connection", connections);
          console.log("nodeData", nodeData);
        }}
        style={{
          width: "90%",
          height: "90vh",
          paddingTop: 30
        }}
        nodes={nodeData}
        connections={conns}
        onNodeDoubleClick={e => {
          setNewNode(e);
          setDisplayInput(true);
        }}
        onConnectionDoubleClick={e => {
          setNewConnection(e);
          setDisplayInput2(true);
        }}
      ></Flowchart>
    </div>
  );
}
